<!--
 * @Author: mzw
 * @Date: 2021-09-18 14:35:27
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-03-20 16:46:20
 * @Description: 发票切换组件
-->
<template>
  <div class="bill-content">
    <el-tabs v-model="activeName" type="card" @tab-click="handleBillClick">
      <el-tab-pane label="增值税专用发票" name="first">
        <BillBox
          :payInvoiceList="payInvoiceSpecialList"
          :activeName="activeName"
          v-if="activeName == 'first'"
          v-bind="$attrs"
          v-on="$listeners"
        />
      </el-tab-pane>
      <el-tab-pane label="增值税普通发票" name="second">
        <BillBox
          :payInvoiceList="payInvoiceCommonList"
          :activeName="activeName"
          v-if="activeName == 'second'"
          v-bind="$attrs"
          v-on="$listeners"
        />
      </el-tab-pane>
      <el-tab-pane v-if="!defaultActive" label="暂时不开发票" name="third"></el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import BillBox from './billBox.vue'
export default {
  data () {
    return {
      activeName: 'third'
    }
  },
  props: {
    payInvoiceInfoList: {
      type: Array,
      default: () => {
        return []
      }
    },
    defaultActive: {
      type: String,
      default: ''
    }
  },
  created () {
    if (this.defaultActive) {
      this.activeName = this.defaultActive
    }
  },
  components: { BillBox },
  computed: {
    payInvoiceSpecialList () {
      return this.payInvoiceInfoList.filter((item) => {
        // 筛选专用发票
        return item.invoiceType == '20'
      })
    },
    payInvoiceCommonList () {
      return this.payInvoiceInfoList.filter((item) => {
        // 筛选普通发票
        return item.invoiceType == '10'
      })
    }
  },
  methods: {
    handleBillClick (tab, event) {
      // console.log(tab.name)
      // console.log(this.activeName)
      this.$emit('toggleInvoice', this.activeName)
    }
    // billChangeHandle(id){
    //     this.$emit('billChangeHandle', id)
    // },
    // invoiceEditHandle(item){
    //     console.log(item)
    //     this.$emit('invoiceEditHandle',item)
    // },
    // invoiceDeleteHandle(item){
    //     debugger
    //     this.$emit('invoiceDeleteHandle',item)
    // }
  }
}
</script>
<style lang="scss" scoped></style>
